export const DEFAULT_FREQUENCY = 50;
export const DEFAULT_FREQUENCIES: number[] = [50, 60];
